export const DATE_FORMAT = {
  DATE_AND_TIME: 'dd.MM.yyyy HH:MM',
  DATE: 'yyyy-MM-dd'
} as const
